import './view.css';
import { mountTemplate } from './modal-base';
import { t } from '../../i18n';

function buildViewTemplate(): string {
  return /* html */ `
<div id="view-modal">
  <div class="modal-content">
    <header class="view-header">
      <h3 id="view-name" style="margin-top:0;color:var(--color-text-dark);text-transform:uppercase;">${t('view.namePlaceholder')}</h3>
      <button
        type="button"
        class="view-close-top"
        onclick="closeViewModal()"
        aria-label="${t('view.close')}"
      >&times;</button>
    </header>
    <div id="view-photo-container"></div>
    <div id="view-gallery" class="view-gallery" hidden></div>
    <p id="view-date" class="view-meta-line" style="font-weight:bold;color:var(--color-text-light);margin:5px 0;"></p>
    <p id="view-meta" class="view-meta-line" style="color:var(--color-text-medium);margin:5px 0;font-size:13px;"></p>
    <p id="view-epitaph" style="font-style:italic;color:var(--color-text-medium);font-size:14px;margin:10px 0;">${t('view.epitaphPlaceholder')}</p>
    <div id="memorial-ad-slot" hidden data-ads-ready="0"></div>
    <section id="view-tributes-section" class="view-tributes-section" hidden>
      <h4 class="view-tributes-title">${t('view.condolences')}</h4>
      <div class="view-candle-row">
        <span id="view-candle-icon" class="view-candle-icon" aria-hidden="true">🕯️</span>
        <p id="view-candle-count" class="view-candle-count">0</p>
      </div>
      <p id="view-flower-count" class="view-flower-count"></p>
      <div class="view-tribute-actions">
        <button type="button" id="view-candle-btn" class="modal-btn view-candle-btn" onclick="lightCandleFromView()">
          ${t('view.lightCandle')}
        </button>
        <button type="button" id="view-flower-btn" class="modal-btn view-flower-btn" onclick="giftFlowerFromView()">
          ${t('pethernity.flower')}
        </button>
      </div>
      <p id="view-candle-cooldown" class="view-tributes-hint" hidden>${t('view.candleCooldown')}</p>
      <p id="view-flower-cooldown" class="view-tributes-hint" hidden>${t('pethernity.flowerCooldown')}</p>
      <div class="view-tributes-feed">
        <div id="view-guest-messages" class="view-guest-messages"></div>
      </div>
      <p id="view-guest-login-cta" class="view-tributes-hint" hidden>
        <button type="button" class="view-tributes-link" onclick="openTributesLogin()">${t('view.loginForTribute')}</button>
        ${t('view.loginForTributeSuffix')}
      </p>
      <form id="view-guest-form" class="view-guest-form" hidden>
        <label for="view-guest-input" class="view-guest-label">${t('view.guestMessageLabel')}</label>
        <textarea id="view-guest-input" maxlength="200" rows="2" placeholder="${t('view.guestMessagePlaceholder')}"></textarea>
        <p id="view-guest-cooldown" class="view-tributes-hint" hidden>${t('view.messageCooldown')}</p>
        <button type="submit" id="view-guest-submit" class="modal-btn view-guest-submit">${t('view.sendCondolence')}</button>
      </form>
    </section>
    <div id="view-family-host"></div>
    <button type="button" id="view-edit-btn" class="modal-btn view-edit-btn" style="display:none;" onclick="openEditHeadstoneModal()">
      ${t('view.editMemorial')}
    </button>
    <p class="view-share-label">${t('view.shareLabel')}</p>
    <div class="view-share-actions">
      <button type="button" class="view-share-network view-share-facebook" onclick="shareMemorialToFacebook()">
        ${t('view.facebook')}
      </button>
      <button type="button" class="view-share-network view-share-instagram" onclick="shareMemorialToInstagram()">
        ${t('view.instagram')}
      </button>
      <button type="button" class="view-share-network view-share-copy" onclick="shareMemorialCopyLink()">
        ${t('view.copyLink')}
      </button>
    </div>
    <button class="view-close-btn" onclick="closeViewModal()">${t('view.close')}</button>
  </div>
</div>
`;
}

export function mountViewModal(): void {
  mountTemplate(
    'view-modal',
    buildViewTemplate().replaceAll('<motion', '<div').replaceAll('</motion>', '</div>'),
  );
}

export function remountViewModal(): void {
  mountViewModal();
}
